import Vue from "vue";
import App from "./App.vue";
import createRouter from "./router";
import store from "./store";
import { sessionStore, persistingStore } from './store/index'
import axios from "axios";

import flatpickr from "flatpickr";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { InlineSvgPlugin } from "vue-inline-svg";
import { PinnaclePermissions, PinnacleEnvironments } from 'pinnacle-lib';
import PlaceSelectionMixin from "@/services/session/PlaceSelectionMixin";
import { initVersionCheck } from "@/services/appVersion/versionCheck.js";
import { formatSize } from "@/utils/formatSize.js";
import VueObserveVisibility from 'vue-observe-visibility';
import { VuePlugin } from 'vuera';
import * as dayjs from 'dayjs';
import { installArtifactMessageGuard } from './components/vibespace/artifact/artifactMessageGuard';

// Set default values for environment variables if not defined
if (!process.env.VUE_APP_AGENT_API) {
  //process.env.VUE_APP_AGENT_API = 'https://api.azira.com/agentic-labs-v1';
  //process.env.VUE_APP_AGENT_API_KEY = "ca4d4b52-18b5-494e-b38a-18ce156538a2";
  process.env.VUE_APP_AGENT_API = 'https://agentic-labs.azira.dev';
  process.env.VUE_APP_AGENT_API_KEY = "";
  if (process.env.VUE_APP_PINNACLE_API == "https://pinn-api-dev.ubermedia.com" || process.env.VUE_APP_PINNACLE_API == "http://localhost:3001") {
    process.env.VUE_APP_AGENT_API = 'https://agentic-labs.azira.dev';
    process.env.VUE_APP_AGENT_API_KEY = "";
  }
}

// Window messages from opaque-origin frames (dashboard artifacts) stop here,
// before any other listener is registered. See artifactMessageGuard.js.
installArtifactMessageGuard();

Vue.use(VuePlugin);

Vue.use(VueObserveVisibility);
Vue.mixin(PlaceSelectionMixin);

Vue.config.productionTip = false;
Vue.use(flatpickr);

// Setup for axios
Vue.prototype.$http = axios.create({
  baseURL: process.env.VUE_APP_PINNACLE_API,
});
Vue.prototype.$sessionStore = sessionStore;
Vue.prototype.$persistingStore = persistingStore;

Vue.use(PinnaclePermissions());
Vue.use(PinnacleEnvironments());

// Inline SVG
Vue.use(InlineSvgPlugin);

// Install BootstrapVue from pinnacle-lib
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);


import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css";
import "flatpickr/dist/flatpickr.min.css";

import "pinnacle-lib/assets/scss/_user.scss";
import "pinnacle-lib/assets/scss/theme.scss";
import "pinnacle-lib/styles/global.scss";
import "@/styles/media.scss";
import "@/assets/scss/map-overrides.scss"

import "pinnacle-lib/assets/js/chart.js";
import "pinnacle-lib/assets/js/clock.js";


Vue.filter("str_limit", (value, size) => {
  if (!value) return "";
  if (!size) size = 23;
  
  value = value.toString();
  
  if (value.length <= size + 3) {
    return value;
  }
  return value.substr(0, size).trim() + "...";
});

Vue.filter("numberToPercentage", (value) => {
  if (!value || isNaN(value)) {
    return value;
  }

  return value.toLocaleString("en", {
    style: "percent",
    minimumFractionDigits: 2,
  });
});

Vue.filter("capitalize", (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
});
Vue.filter("formatDate", (value) => {
  return dayjs(value).format('MM/DD/YYYY');
});
Vue.filter("formatDateTime", (value) => {
  return dayjs(value).format('MM/DD/YYYY h:mm A');
});
Vue.filter("formatFileSize", (bytes) => {
  if (!bytes) return '0 B';
  var k = 1000;
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
});
Vue.filter("formatSize", formatSize);
Vue.filter("formatNumber", (value) => {
  if (!value || isNaN(value)) return value;
  return value.toLocaleString();
});
Vue.filter("formatNumberWithUnits", (value, units) => {
  let str = value.toLocaleString() + ' ' + units;
  if (value === 1) {
    str = value.toLocaleString() + ' ' + units.slice(0, -1); // Remove last character for singular
  }
  return str;
});



Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

// Brand avatar mixins

const iconContainerStyle = {
  background: '#EAF2FD',
  padding: '8px !important'
};
const logoContainerStyle = {
  textAlign: 'center'
};
const iconStyle = {
  filter: `invert(55%) sepia(40%) saturate(294%) hue-rotate(175deg) brightness(86%) contrast(87%)`
};
const logoStyle = {
};

Vue.mixin({
  methods: {
    getCategoryAvatar(location) {
      // if(!location.avatar_category) return location.avatar_subsector;
      // else if (!location.avatar_subsector.endsWith("svg")) return location.avatar_sector;
      // else return location.avatar_category;

      // if (location.avatar_category && location.avatar_category.endsWith("svg")) return location.avatar_category;
      if (location.avatar_category) return location.avatar_category;
      else if (location.avatar_subsector && location.avatar_subsector.endsWith("svg") && location.avatar_subsector !== "None") return location.avatar_subsector;
      else return location.avatar_sector;

    },
    getImgContainerStyle(location) {
      if (!location || !location.avatar_category) return iconContainerStyle;
      return logoContainerStyle;
    },
    getImgStyle(location) {
      if (!location || (!location.avatar_category && (location.avatar_subsector !== null && location.avatar_subsector.endsWith("svg")))) return iconStyle;
      return logoStyle;
    },
    getImgContainerClass(location) {
      if (!location || !location.avatar_category) return 'fallback-icon';
      return 'avatar-logo';
    },
    goBack(crumb) {
      if (crumb === undefined || crumb === null) this.$router.go(-1);
      if (crumb.path === this.$route.path && JSON.stringify(crumb.query) === JSON.stringify(this.$route.query)) return;
      const newCrumb = Object.assign({}, crumb);

      // TODO: Move this logic to configuration, this is a hack
      if (this.$route.params.ids !== undefined && !this.$route.path.includes('preview')) crumb.params.ids = this.$route.params.ids;

      newCrumb.meta.ignoreCrumb = true;
      this.$sessionStore.commit('popCrumb');
      this.$router.push(newCrumb);
    },
  }
})

export const bus = new Vue();

new Vue({
  router: createRouter(),
  store,
  render: (h) => h(App),
}).$mount("#app");

// Initialize the Version_Checker after the root Vue instance is mounted so the
// bus and router already exist. The checker receives the already-exported bus
// by injection (it never imports main.js) to avoid a circular import.
initVersionCheck({ bus });
